module.exports = __webpack_public_path__ + "img/Fabric_trading.f5adc551.png";